var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-stepper",
        {
          model: {
            value: _vm.currentStep,
            callback: function($$v) {
              _vm.currentStep = $$v
            },
            expression: "currentStep"
          }
        },
        [
          _c(
            "v-stepper-header",
            [
              _c(
                "v-stepper-step",
                { attrs: { complete: _vm.currentStep > 1, step: "1" } },
                [_vm._v("\n        Login\n      ")]
              ),
              _vm._v(" "),
              _c("v-stepper-step", { attrs: { step: "2" } }, [
                _vm._v("\n        Accept Invitation\n      ")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-stepper-items",
            [
              _c(
                "v-stepper-content",
                { attrs: { step: "1" } },
                [
                  _c("login-form", {
                    on: {
                      success: function($event) {
                        _vm.currentStep = 2
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-stepper-content",
                { attrs: { step: "2" } },
                [
                  _c("h3", [
                    _vm._v(
                      "\n          accept invitation from " +
                        _vm._s(_vm.companyName) +
                        " ?\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mx-0 px-0",
                      attrs: { color: "primary" },
                      on: { click: _vm.acceptInvitation }
                    },
                    [_vm._v("Accept")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "accent--text",
                      attrs: { flat: "" },
                      on: { click: _vm.declineInvitation }
                    },
                    [_vm._v("Refuse")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9bd0feda", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9bd0feda","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/User/DispatchInvite.vue
// module id = null
// module chunks = 